// extracted by mini-css-extract-plugin
export default {"gridDocuments":"debit_gridDocuments__stF8P"};